import {
  Editor,
  Collection,
  addListToDropdown,
  ButtonExecuteEvent,
  createDropdown,
  ListDropdownItemDefinition,
  ViewModel,
} from "ckeditor5";

import TablePropertyCommand from "../../_nonpublic/table/tablepropertycommand";

import { TableStyleDefinition } from "./utils";

export const COMMAND_TABLE_CLASSES = "tableClasses";
export const UI_DROPDOWN_TABLE_STYLES = "tableStyles";

export const createMenu = (
  editor: Editor,
  definitions: Record<string, TableStyleDefinition>,
) => {
  const command = new TablePropertyCommand(editor, "tableClass");
  editor.commands.add(COMMAND_TABLE_CLASSES, command);

  editor.ui.componentFactory.add(UI_DROPDOWN_TABLE_STYLES, (locale) => {
    const dropdown = createDropdown(locale);
    dropdown.buttonView.set({
      label: "Quick Styles",
      withText: true,
    });

    const items = new Collection<ListDropdownItemDefinition>();

    for (const style of [undefined, ...Object.values(definitions)]) {
      const model = new ViewModel({
        label: style?.name ?? "None",
        role: "menuitemradio",
        withText: true,
      });

      model
        .bind("isOn")
        .to(
          command,
          "value",
          (value) => (value ?? "None") === (style?.name ?? "None"),
        );

      items.add({ type: "button", model });
    }

    addListToDropdown(dropdown, items);

    dropdown.on<ButtonExecuteEvent>("execute", (e) => {
      const source = e.source as { label: string };
      if (source.label === "None") {
        command.execute({ value: undefined });
      } else {
        command.execute({
          value: source.label,
        });
      }
    });

    return dropdown;
  });
};
